import { ReactElement, useState } from 'react';
import { PAGE_ICONS } from 'pages/AnnualUserAccessReview/_const';
import PageWithBreadcrumbs from 'pages/AnnualUserAccessReview/layouts/UARPageWithBreadcrumbs';
import RenewForm from './RenewForm';
import CssBaseline from '@mui/material/CssBaseline';
import HelpBar, {
	Main,
} from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/components/HelpBar';
import Typography from '@mui/material/Typography';
import HelpLayout from 'layouts/HelpLayout';
import FormLayout from 'layouts/FormLayout';

/**
 * View where manager can review, validate, and renew non-employee access
 * @returns {ReactElement} User Access Review Non-Employee Review page view
 */
const RenewView = () => {
	const [sOpen, setOpen] = useState(false);
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'Review and Renew Non-Employee Access'}
			CurrentPageIcon={PAGE_ICONS.RENEW}
		>
			<CssBaseline />
			<Main open={sOpen}>
				<FormLayout
					title={'Renew Non Employee Access'}
					setOpen={() => setOpen(!sOpen)}
				>
					<RenewForm />
				</FormLayout>
			</Main>
			<HelpBar open={sOpen} setOpen={setOpen}>
				<HelpLayout title='Renew Non Employee Access'>
					<Typography>
						Allows for manager to review and renew access to UPMC
						applications for non employee staff members
					</Typography>
					<br></br>
					<Typography>
						For more information, please check on{' '}
						<a
							target='_blank'
							rel='noopener noreferrer'
							href='https://infonet.upmc.com/infonet/ls/content/7110935095706041/non-employee-expiration-renewal-pdf-1764799983'
						>
							InfoNet
						</a>
					</Typography>
				</HelpLayout>
			</HelpBar>
		</PageWithBreadcrumbs>
	);
};

export default RenewView;
